// extracted by mini-css-extract-plugin
export default {"NoRecordingsNotice":"AllRecordingsView_NoRecordingsNotice__qJ0Cj"};